import PropTypes from 'prop-types';

import { ChevronDownIcon } from 'lucide-react';
import { Separator, SimpleAlert, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, Button } from 'twyne-new.ui';

import { ActiveForm } from '@/components/form/ActiveSwitch';
import HeaderContainerForm from '@/components/headerContainer/Form';
import { formatDateTime } from '@/utils';
import history from '@/utils/history';
import { useStatusForm } from '@Components/form/context';
import PageVariablesModal from 'components/modals/PageVariablesModal';

function PathHeading({ data, active, onChangeActive }) {
  const { status } = useStatusForm()

  return <HeaderContainerForm
    title='Path'
    data={{ ...data, createdAt: formatDateTime(data?.created_at), updatedAt: formatDateTime(data?.updated_at) }}
    onCancel={() => history.goBack()}
  >
    {(status.hasChange && data?.id) && <SimpleAlert variant='warning' className='px-4 py-2'>
      You have unsaved changes
    </SimpleAlert>}
    <ActiveForm active={active} onChangeActive={onChangeActive} />
    <Separator orientation='vertical' className='py-5' />
    <DropdownMenu optionsLabel='Options' >
      <DropdownMenuTrigger className='flex items-center gap-1'>
        <Button size='lg' variant='outline'>
          Quick Actions
          <ChevronDownIcon size={16} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='start' forceMount
        onCloseAutoFocus={e => e.preventDefault()}
        onFocusOutside={e => e.preventDefault()}
      >
        <PageVariablesModal />
      </DropdownMenuContent>
    </DropdownMenu>
  </HeaderContainerForm>
}

PathHeading.propTypes = {
  data: PropTypes.object,
};

export default PathHeading
